/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for reading a competitor member.
 * @export
 * @interface CompetitorMemberRead
 */
export interface CompetitorMemberRead {
    /**
     * 
     * @type {string}
     * @memberof CompetitorMemberRead
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitorMemberRead
     */
    user_name?: string | null;
}

/**
 * Check if a given object implements the CompetitorMemberRead interface.
 */
export function instanceOfCompetitorMemberRead(value: object): value is CompetitorMemberRead {
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    return true;
}

export function CompetitorMemberReadFromJSON(json: any): CompetitorMemberRead {
    return CompetitorMemberReadFromJSONTyped(json, false);
}

export function CompetitorMemberReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitorMemberRead {
    if (json == null) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'user_name': json['user_name'] == null ? undefined : json['user_name'],
    };
}

export function CompetitorMemberReadToJSON(json: any): CompetitorMemberRead {
    return CompetitorMemberReadToJSONTyped(json, false);
}

export function CompetitorMemberReadToJSONTyped(value?: CompetitorMemberRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['user_id'],
        'user_name': value['user_name'],
    };
}

